import "./TodosError.css";

function TodosError() {
  return (
    <p>
      Oops! 🚨
      <br />
      Something went wrong
    </p>
  );
}

export { TodosError };
